<div class="error-feedback-container">
  <div class="left">
    <span class="error-feedback d-block">{{ 'Rewards.' + componentType() + '_LOAD_ERROR_LABEL' | translate }}</span>
    <span class="error-feedback d-block">{{ 'Rewards.TRY_LATER' | translate }}</span>
  </div>

  <div class="right">
    <span class="material-symbols-sharp icon">cloud_alert</span>
  </div>
</div>
